"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartResultSchema = exports.ChartPointResultSchema = void 0;
const zod_1 = require("zod");
exports.ChartPointResultSchema = zod_1.z.object({
    timestamp: zod_1.z.string().datetime(), // ISO 8601
    value: zod_1.z.number(),
    valueUnits: zod_1.z.string(),
});
exports.ChartResultSchema = zod_1.z.object({
    chartPoints: zod_1.z.array(exports.ChartPointResultSchema),
});
